import withSharedStyles from "../../theme/Shared.style";

const withCustomStyles = withSharedStyles(theme => {
  const { color, control, radius, shadow } = theme.tokens;
  const reset = {
    appearance: "none",
    border: 0,
    margin: 0,
    padding: 0,
    font: "inherit",
    cursor: "pointer",
    display: "flex",
    alignItems: "center",
    justifyContent: "center"
  };

  return {
    addRound: {
      ...reset,
      width: control.sm,
      height: control.sm,
      borderRadius: radius.pill,
      backgroundColor: color.bg,
      color: color.ink,
      transition: "background-color .15s, color .15s",
      "&:hover": { backgroundColor: color.ink, color: color.bg }
    },
    pill: {
      height: control.sm,
      borderRadius: radius.pill,
      backgroundColor: color.ink,
      color: color.bg,
      display: "inline-flex",
      alignItems: "center",
      justifyContent: "space-between"
    },
    tile: {
      boxShadow: shadow.float,
      "&$pill": { boxShadow: shadow.overlay }
    },
    inline: {
      "&$addRound": {
        backgroundColor: color.field,
        "&:hover": { backgroundColor: color.ink, color: color.bg }
      }
    },
    lg: {
      "&$pill": {
        width: "100%",
        height: control.lg,
        "& $stepBtn": { width: control.lg, height: control.lg },
        "& $qty": { fontSize: theme.tokens.fontSize.title }
      }
    },
    stepBtn: {
      ...reset,
      width: control.sm,
      height: control.sm,
      borderRadius: radius.pill,
      background: "none",
      color: "inherit",
      "&:hover": { backgroundColor: color.inkHover }
    },
    disabled: {
      opacity: 0.4,
      cursor: "not-allowed",
      "&:hover": { background: "none" }
    },
    qty: {
      minWidth: 16,
      textAlign: "center",
      fontWeight: 800,
      fontSize: theme.tokens.fontSize.body
    }
  };
});

export default withCustomStyles;
